.mainContent {
    font-size: 90%;
}

.mainContent hr {
    color: #996600;
    height: 2px;
}

.mainContent a {
    font-size: 90%;
    font-weight: bold;
    color: #3366ff;
    text-decoration: none;
}

.mainContent a:hover {
    color: #ff9900;
}
